"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.generateChatId = void 0;

var _cryptoBrowserify = _interopRequireDefault(require("crypto-browserify"));

function normalizeNumber(str) {
  var string = str;

  if (typeof string !== 'string') {
    string = string.toString();
  }

  string = string.replace('+', '');

  if (string.length === 10) {
    string = "1".concat(string);
  }

  return string;
}
/**
 *
 * @param {string|int|null} dialed
 * @param {string|null} domain
 * @param {string|int|null} fromNum
 * @param {string|null} fromUID
 * @param {string|int|null} termNum
 * @param {string|null} termUID
 * @return {string}
 */


var generateChatId = function generateChatId(_ref) {
  var _ref$dialed = _ref.dialed,
      dialed = _ref$dialed === void 0 ? null : _ref$dialed,
      _ref$domain = _ref.domain,
      domain = _ref$domain === void 0 ? null : _ref$domain,
      _ref$fromNum = _ref.fromNum,
      fromNum = _ref$fromNum === void 0 ? null : _ref$fromNum,
      _ref$fromUID = _ref.fromUID,
      fromUID = _ref$fromUID === void 0 ? null : _ref$fromUID,
      _ref$termNum = _ref.termNum,
      termNum = _ref$termNum === void 0 ? null : _ref$termNum,
      _ref$termUID = _ref.termUID,
      termUID = _ref$termUID === void 0 ? null : _ref$termUID;
  var arr = [];

  if (domain) {
    arr.push(domain);
  }

  if (fromNum) {
    arr.push(normalizeNumber(fromNum));
  }

  if (fromUID) {
    arr.push(fromUID);
  }

  if (termUID) {
    arr.push(termUID);
  }

  if (termNum) {
    arr.push(normalizeNumber(termNum));
  }

  if (dialed) {
    arr.push(normalizeNumber(dialed));
  }

  arr.sort();
  var merged = arr.join('');
  return _cryptoBrowserify.default.createHash('md5').update(merged).digest('hex');
};

exports.generateChatId = generateChatId;